export const TrackingModeHeader = 'zmobile-trackingmode';
export const TrackingModeCookie = 'zl_tracking_mode';
export const TrackingModeCookieOptions = {
    maxAge: 24 * 60 * 60 * 1000,
    httpOnly: false,
    secure: process.env.NODE_ENV === 'production',
};
export const TrackingMode = {
    NoConsent: 'no_consent',
    InWeb: 'in_web',
    InApp: 'in_app',
};
export const isValidTrackingMode = (trackingMode) => Object.values(TrackingMode).includes(trackingMode);
export const escapeHtml = (text = '') => {
    const encodeMap = {
        '<': '\\u003C',
        '>': '\\u003E',
    };
    return text.replace(/[<>]/g, match => {
        return encodeMap[match];
    });
};
export const isClient = () => typeof window !== 'undefined';
//# sourceMappingURL=utils.js.map